import "./style.css";

export const FloatPanel = ({ template }) => {
  const Panel = () => {
    return (
      <>
        <div className={`floatPanel slide-left`}>{template}</div>
        <div className="shadow"></div>
      </>
    );
  };

  return <Panel />;
};
